export { PressOptions, press, longPress } from './press';
